{
  "version": 1,
  "asset_id": "a85d5487-f6a0-4871-a725-56f1ee6052ae",
  "project_id": "1c7313b7-7160-4256-be8b-cc48c05288da",
  "url": "/__l5e/assets-v1/a85d5487-f6a0-4871-a725-56f1ee6052ae/sig-iata.png",
  "r2_key": "a/v1/1c7313b7-7160-4256-be8b-cc48c05288da/a85d5487-f6a0-4871-a725-56f1ee6052ae/sig-iata.png",
  "original_filename": "sig-iata.png",
  "size": 68749,
  "content_type": "image/png",
  "created_at": "2026-09-22T12:21:32Z"
}
